import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import Video1 from '../assets/video/video1.mp4';
import HomeImg1 from '../assets/images/home/home-img1.png';

const HomeHeroSlider: React.FC = () => {
    return (
        <>
            <Swiper
                slidesPerView={1}
                allowTouchMove={false}
                className="swiper hero-slider"
                style={{ height: '955px' }}
            >
                <SwiperSlide className="swiper-slide main-swiper-slide video-slide">
                    <video autoPlay muted loop playsInline>
                        <source src={Video1} type="video/mp4" />
                    </video>
                    <div className="slide-content">
                        <div className="container">
                            <div className="row main-swiper-row">
                                <div className="col-xxl-6 col-xl-6 col-lg-10 clearfix-space animate-slide">
                                    <p className="needs-text">profesjonalne sprzątanie</p>
                                    <h1 className="lets-us-do">SprzątAsia – Twój dom zawsze lśniący</h1>
                                    <h2 className="residents">Kompleksowe sprzątanie domów, biur i obiektów. Jeden telefon, jeden klik – i my się wszystkim zajmujemy.</h2>
                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-10 position-relative">
                                    <img className="home-img-clening" src={HomeImg1} alt="home-img1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </>
    )
}

export default HomeHeroSlider
